module.exports = __webpack_public_path__ + "media/images/siq-slider-dots-98d5be8bf18737d31d16c16cbfa06fd7.png";